<div class="container rounded bg-white mt-0">
    <div class="row">
        <div class="col-md-3">
            <div class="d-flex flex-column align-items-center text-center p-3 py-5"><img class="rounded-circle mt-5" width="150px" src="../../../assets/images/faces/face28.png" alt="profile"><span class="font-weight-bold">{{firstName}}</span><span class="text-black-50">{{email}}</span><span> </span></div>
        </div>
        <div class="col-md-6">
            <div class="p-1 py-4">
                <div class="d-flex justify-content-between align-items-center mb-1">
                    <h4 class="text-right">User Profile</h4>
                </div>
                <div class="row mt-5">
                    <div class="col-md-12 font-weight-bold" ><label class="labels">First Name</label><input type="text" class="form-control" placeholder={{firstName}} readonly></div>
                    <div class="col-md-12 font-weight-bold"><label class="labels">Last Name</label><input type="text" class="form-control"placeholder={{lastName}}  readonly ></div>
                    <br>
                  
                    <div class="col-md-12 font-weight-bold"><label class="labels">Department</label><input type="text" class="form-control" readonly  placeholder={{DepartmentName}}></div>
                    <div class="col-md-12 font-weight-bold"><label class="labels">Designation</label><input type="text" class="form-control" readonly placeholder={{DesignationName}}></div>
                    <br>  
                    
                    <div class="col-md-12 font-weight-bold"><label class="labels">Email</label><input type="text" class="form-control" readonly placeholder={{email}}></div>
                    <div class="col-md-12 font-weight-bold"><label class="labels">Function</label><input type="text" class="form-control" readonly placeholder={{FunctionName}}></div>
                    <br>
               </div>
               <br>
              
               
               <div class="row mt-5">
                <div class="col" >
                    <div class="form-group">
                      <label for="proposedBand">Availability</label>
                      <ng-select [(ngModel)]="Band"  (ngModelChange)="onChangeAvailability($event)" id="proposedBand" name="proposedBand">
                        <ng-option *ngFor="let b of availability" [value]="b.name">{{b.name}}
                          </ng-option>
                      </ng-select>
                    </div>
                  </div>

                  <div *ngIf="isAwayVisible" class="col-md-12 font-weight-bold" >Availability<label class="labels"></label><input type="text" class="form-control" placeholder={{available}} readonly></div>
                  <div *ngIf="isAwayVisible" class="col-md-12 font-weight-bold" >DOA<label class="labels"></label><input type="text" class="form-control" placeholder={{Doa}} readonly></div>
               </div>
                <br>
                
                <div class="row  mt-3" *ngIf="isNotAvailableVisible">
                    <br>
                    <br>
                    <div class="col-md-6"><label class="labels">Start Date</label><input type="date" [(ngModel)]="startDate" class="form-control" value=""></div>
                    <br>
                    <br>
                    <div class="col-md-6"><label class="labels">End Date</label><input type="date"  [(ngModel)]="EndDate" class="form-control"  value=""></div>
                   <br>
                   <br>
                   <div class="col-md-12"><label class="labels">DOA</label>
                   <ng-select  required [(ngModel)]="DoaId"  id="DoaId"  name="DoaId">
                    <ng-option *ngFor="let manager of Managers" [value]="manager.email">
                      {{manager.firstName}} -   {{manager.email}}</ng-option>
                  </ng-select>
                </div>
                      </div>
                    
     
                <div class="mt-5 text-center"><button class="btn btn-primary profile-button" (click)="Submit()" type="button">Save Profile</button></div>
            
        </div>
    </div>
</div>